import { Header, TableCell, TableRow } from '@/platform/ui';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const NoDataRow = ({ numberOfColumns }) => (
    <TableRow>
        <TableCell
            colSpan={numberOfColumns}
            textAlign='center'
            className='bg-white'
        >
            <div className='flex flex-col items-center gap-2 py-10 text-gray-500'>
                <MagnifyingGlassIcon className='size-10 text-gray-700' />
                <Header as='h3' className='text-gray-700'>
                    Geen resultaten gevonden
                </Header>
                <p className='text-sm'>
                    Probeer je filters of zoekcriteria aan te passen.
                </p>
            </div>
        </TableCell>
    </TableRow>
);

export default NoDataRow;
